(() => {
  if (window.koperoSetInstalled) return;
  window.koperoSetInstalled = true;
  function update(form) {
    let cents = 0, available = true;
    form.querySelectorAll('select').forEach(select => {
      const option = select.selectedOptions[0];
      if (!option || option.disabled) available = false;
      cents += Number(option?.dataset.price || 0);
      const card = select.closest('.ke-set__product');
      card.querySelector('[data-set-price]').textContent = option?.dataset.money || '';
      const img = card.querySelector('img');
      if (img && option?.dataset.image) {
        img.src = option.dataset.image;
        img.removeAttribute('srcset');
      }
    });
    form.querySelector('[data-set-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'nl', {style:'currency', currency:form.dataset.currency || 'EUR'}).format(cents / 100);
    if (!form.dataset.busy) form.querySelector('button[type="submit"]').disabled = !available;
  }
  document.addEventListener('change', e => {
    const form = e.target.closest('form[data-ke-set]');
    if (form) {
      form.querySelector('[data-set-status]').textContent = '';
      update(form);
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const id = event.data?.variant?.id;
      if (!id) return;
      document.querySelectorAll('form[data-ke-set]').forEach(form => {
        const select = form.querySelector('select');
        if ([...select.options].some(option => option.value === String(id))) {
          select.value = String(id);
          update(form);
        }
      });
    });
  }
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ke-set]');
    if (!form) return;
    e.preventDefault();
    if (form.dataset.busy) return;
    const selects = [...form.querySelectorAll('select')];
    if (selects.some(s => !s.selectedOptions[0] || s.selectedOptions[0].disabled)) return;
    form.dataset.busy = '1';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-set-status]');
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    status.textContent = '';
    const cart = document.querySelector('cart-drawer');
    const payload = {items:selects.map(s => ({id:Number(s.value),quantity:1,properties:{_bron:'productset'}}))};
    if (cart?.getSectionsToRender) {
      payload.sections = cart.getSectionsToRender().map(s => s.id);
      payload.sections_url = location.pathname;
      cart.setActiveElement(button);
    }
    try {
      const response = await fetch(window.routes?.cart_add_url || form.action,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || form.dataset.error);
      status.textContent = form.dataset.success;
      if (cart && data.sections && Object.values(data.sections).every(Boolean)) {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'kopero-set',cartData:data});
      } else location.href = window.routes?.cart_url || '/cart';
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
    } finally {
      delete form.dataset.busy;
      button.removeAttribute('aria-busy');
      update(form);
    }
  });
})();
